import React, { useEffect, useState } from 'react'
import { Tabs, message } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import TabPane from 'antd/es/tabs/TabPane'
import { useMutation } from 'react-query'
import { Link, useParams, useNavigate } from 'react-router-dom'
import {
  setSelectedScenario,
  setScenerioClick,
  setScenarioId,
  setEnableBackgroundCalc,
  setInterimId,
  setRefreshClick,
  setActiveKey,
  setIsRefreshFlag,
  setRefreshApiTrigger,
  updateEditScenerioCheck,
  setScenarioName,
  setCreatedScenerioUserName,
  setSelectedScenarioRecord,
  setIsScenarioChangesDetectedFlag,
  setHistoricalStartEndDateForScenario,
  setAnalysisDate,
  setSelectedAccounts,
  setSelectedAccountDetails,
  setScenarioType,
  setSharePercent,
  updateEditScenerioInitialClick
} from '../../reducer/CommonSlice'
import {
  updateContractComparisonWACData,
  updateSelectedContractStructureTemplatesIds
} from '../../reducer/contractComparison/contractComparisonSlice'
import GlobalInputsLayout from '../globalInputs/globalInputs'
import TableComponent from '../landingPage/TableComponent'
import './headerTabs.scss'
import { deleteInterimScenarioDetails } from '../../services/createScenarioApi'
// "../../services/createScenarioApi";

import {
  updateCstDefaultValue,
  updateAccountDefaultValue,
  updateselectedAccountSummaryHeaderAccountDD,
  updateselectedAccountSummaryHeaderContractDD
} from '../../reducer/accountSummary/accountSummarySlice'
import { updateInitialCustomerPOV } from '../../reducer/customerPov/customerPovSlice'

const Header = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { master_url, sub_url } = useParams()
  const [activeKeys, setActiveKeys] = useState('1')

  const {
    isLoading: isDeleteInterimScenarioDetailsLoading,
    data: deleteInterimScenarioDetailsResponse,
    mutate: mutateDeleteInterimScenarioDetails
  } = useMutation(deleteInterimScenarioDetails)

  const selectedScenario = useSelector((state) => state.Common.selectedScenario)
  const refreshDate = useSelector((state) => state.Common.refreshDate)
  const isLoginLoading = useSelector((state) => state.Common.isLoginLoading)
  const interimScenarioId = useSelector((state) => state.Common.interim_scenario_id)
  const isScenarioChangesDetectedFlag = useSelector(
    (state) => state.Common.isScenarioChangesDetectedFlag
  )

  useEffect(() => {
    const activeIndex = items?.findIndex((item) => item?.directPath === `/${master_url}`)
    setActiveKeys(activeIndex >= 0 ? (activeIndex + 1).toString() : '1')
  }, [master_url, sub_url])

  const items = [
    {
      key: '1',
      label: 'Scenarios',
      directPath: '/',
      Children: <TableComponent />
    },
    {
      key: '2',
      label: 'Global Inputs',
      directPath: '/global-inputs',
      Children: <GlobalInputsLayout />
    }
  ]
  const tabClickHandler = (e) => {
    if (selectedScenario) {
      // const user_id =
      if (interimScenarioId != null) {
        if (isScenarioChangesDetectedFlag) {
          message.warning('You are leaving the page, any unsaved changes will be lost.')
          dispatch(setIsScenarioChangesDetectedFlag(false))
        }
        mutateDeleteInterimScenarioDetails(
          {
            model: {
              filters: [],
              list_details: [],
              settings: {
                interim_scenario_id: interimScenarioId
              }
            },
            user_id: sessionStorage.getItem('user_id'),
            application_role: sessionStorage.getItem('application_role')
          },
          {
            onSuccess: () => {
              dispatch(setIsRefreshFlag('N'))
              dispatch(setScenarioId(null))
              dispatch(setInterimId(null))
              dispatch(setRefreshClick(false))
              dispatch(updateEditScenerioCheck(false))
              dispatch(setActiveKey(1))
              dispatch(updateInitialCustomerPOV(false))
              dispatch(updateCstDefaultValue(null))
              dispatch(updateAccountDefaultValue(null))
              dispatch(
                setHistoricalStartEndDateForScenario([refreshDate.start_date, refreshDate.end_date])
              )
              dispatch(setAnalysisDate([refreshDate.start_date, refreshDate.end_date]))
              dispatch(updateselectedAccountSummaryHeaderAccountDD({}))
              dispatch(updateselectedAccountSummaryHeaderContractDD({}))
              dispatch(updateSelectedContractStructureTemplatesIds([]))
              dispatch(setEnableBackgroundCalc(true))
              dispatch(updateContractComparisonWACData([]))
              dispatch(setScenerioClick(false))
              dispatch(setSelectedScenario(false))
              dispatch(setSelectedAccounts([]))
              dispatch(updateEditScenerioInitialClick(false))
              dispatch(setSelectedAccountDetails([]))
              dispatch(setScenarioType('Regular'))
              dispatch(setSharePercent(80))
              dispatch(setCreatedScenerioUserName(null))
              dispatch(setSelectedScenarioRecord(null))
              // handleComponentWillUnmount(false);
            }
          }
        )
      }
      // dispatch(setSelectedScenario(false));
    }

    navigate('/')
    dispatch(setSelectedScenario(false))
    dispatch(setScenerioClick(true))
    dispatch(setRefreshApiTrigger(true))
  }

  useEffect(() => {
    const handleUnload = () => {
      if (!interimScenarioId) return
      dispatch(setIsScenarioChangesDetectedFlag(false))
      navigate('/', { replace: true })
      const baseURL = process.env.REACT_APP_BASE_API_URL
      const deleteEndpoint = `${baseURL}/scenario/deleteInterimScenarioDetails`
      const payload = {
        model: {
          filters: [],
          list_details: [],
          settings: {
            interim_scenario_id: interimScenarioId
          }
        },
        user_id: sessionStorage.getItem('user_id'),
        application_role: sessionStorage.getItem('application_role')
      }
      fetch(deleteEndpoint, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        keepalive: true
      })
    }
    window.addEventListener('beforeunload', handleUnload)
    return () => {
      window.removeEventListener('beforeunload', handleUnload)
    }
  }, [interimScenarioId, isScenarioChangesDetectedFlag])

  return (
    <Tabs activeKey={activeKeys} className="header-tab-group">
      {items.map((item) => (
        <TabPane
          key={item.key}
          destroyInactiveTabPane={true}
          disabled={isLoginLoading}
          tab={
            <>
              {!isLoginLoading && (
                <Link
                  onClick={(e) => {
                    if (isLoginLoading) {
                      e.preventDefault()
                      return
                    }
                    tabClickHandler(e)
                  }}
                  to={item?.directPath}
                  className={
                    item?.key === activeKeys ? 'header-tab-header-active' : 'header-tab-header'
                  }
                  // onClick={(e)=> tabClickHandler(e)}
                >
                  {item?.label}
                </Link>
              )}
            </>
          }
        >
          {item?.Children}
        </TabPane>
      ))}
    </Tabs>
  )
}
export default Header
